import React from 'react';
import { NavigationBar as HeaderView } from 'components/views/organisms/NavigationBar';
import { useToggleSidebarVisibility, useSidebarVisibility } from 'services/useSidebarVisibility';
import { useNavigate } from 'react-router';
import { useProjects } from 'services/useProjects';
import { useSelectedProject, useSelectProject } from 'services/useSelectedProject';
import { Project } from 'core/models/project';
import { useEnvironments } from 'services/useEnvironments';
import { useSelectedEnvironment, useSelectEnvironment } from 'services/useSelectedEnvironment';
import { Environment } from 'core/models/environment';
import { useSignOut } from 'services/oidc/useSessionController';
import { useMultiScreenEnabler } from '../useMultiScreenEnabler';
import { ignore } from 'utility/ignore';

export type NavigationBarProps = {}

export const NavigationBar = (props: NavigationBarProps) => {
    ignore(props);

    const navigate = useNavigate();
    const sidebarVisibility = useSidebarVisibility();
    const toggleSidebar = useToggleSidebarVisibility();
    const projects = useProjects();
    const selectedProject = useSelectedProject();
    const selectProject = useSelectProject();
    const environments = useEnvironments(selectedProject?.id);
    const selectedEnvironment = useSelectedEnvironment(environments);
    const selectEnvironment = useSelectEnvironment();
    const signOut = useSignOut();
    const _props = {
        sidebarButtonVisible: sidebarVisibility,
        projects,
        environments,
        selectedProject,
        selectedEnvironment,
        onHomeButtonClick: () => navigate('../console/dashboard'),
        onSidebarButtonClick: () => toggleSidebar(),
        onExitButtonClick: () => signOut(),
        onProjectSelected: (project: Project) => selectProject(project),
        onEnvironmentSelected: (environment: Environment) => selectEnvironment(environment),
        ...useMultiScreenEnabler(),
    };

    return (
        <HeaderView {..._props} />
    );
};
